/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { getNameClient } from '../../helpers/nameClient';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { changeTitleBanner } from '../../store/actions';
import usePageTitle from '../../common/hooks/usePageTitle';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Page, Card, EmptyState } from '../../components/ihub';

// Solo se muestra un iframe que esté en los permisos del usuario (localStorage 'permisos', igual que el menú).
// Si alguien escribe a mano /Iframe/<id> sin ese permiso, ve la pantalla de "No access" del kit.
const Iframe = (props: any) => {
    const dispatch = useDispatch();
    const { id } = useParams<any>();
    const PageTitleRolM = usePageTitle(props.location.pathname);
    const [state, setState] = useState<any>({ currentIframe: undefined, revisado: false });

    useEffect(() => {
        let permissions: any[] = [];
        try {
            permissions = JSON.parse(String(localStorage.getItem('permisos'))) || [];
        } catch (e) {
            permissions = [];
        }
        const currentIframe = Array.isArray(permissions) ? permissions.find((item: any) => item.id == id) : undefined;

        if (currentIframe && currentIframe.identificator === "iFrame") {
            dispatch(changeTitleBanner(currentIframe.nombre));
            setState({ currentIframe, revisado: true });
        } else {
            dispatch(changeTitleBanner(''));
            setState({ currentIframe: undefined, revisado: true });
        }
    }, [id]);

    if (!state.revisado) return null;

    if (!state.currentIframe) {
        return (
            <Page theme="brand" title="No access">
                <PageTitle>
                    <title>No access | {getNameClient()}</title>
                </PageTitle>
                <Card>
                    <EmptyState icon="bx-lock-alt" title="No access" text="You don't have access to this page." />
                </Card>
            </Page>
        );
    }

    if (!state.currentIframe.code) {
        return (
            <Page theme="brand" title={state.currentIframe.nombre}>
                <PageTitle>
                    <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Card>
                    <EmptyState icon="bx-wrench" title="Not set up yet" text="This page doesn't have content yet." />
                </Card>
            </Page>
        );
    }

    return (
        <React.Fragment>
            <PageTitle>
                <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
            </PageTitle>
            <div className='pt-5 mt-4 pe-1' dangerouslySetInnerHTML={{ __html: state.currentIframe.code }} />
        </React.Fragment>
    );
};

export default Iframe;
